import { FunctionComponent, useState } from "react";
import { useTranslation } from "react-i18next";

import { CircularProgress } from "@mui/material";

import { CustomColumnTypes } from "@/enum/list.enum";
import { runOrToast } from "@/utils/runOrToast";

import { Checkbox } from "@/components/Checkbox/Checkbox";

import { useUpdateCostumColumnMutation } from "@/pages/Private/redux/list/list.api";

import { ListPerson } from "../../schema/list";
import { ColumnValue } from "../../schema/columnValue";
import { ColumnConfig } from "../../schema/columnConfig";

export interface CustomBooleanColumnProps {
	columnValue?: ColumnValue;
	columnConfig: ColumnConfig;
	row: ListPerson;
	type: CustomColumnTypes;
}

export const CustomBooleanColumn: FunctionComponent<CustomBooleanColumnProps> = ({
	columnValue,
	columnConfig,
	row,
	type,
}) => {
	const [updatePerson, { isLoading }] = useUpdateCostumColumnMutation();
	const { t } = useTranslation();
	const [isChecked, setIsChecked] = useState(
		columnValue?.value ? (columnValue.value as boolean) : false
	);

	return isLoading ? (
		<CircularProgress />
	) : (
		<Checkbox
			isChecked={columnValue?.value ? (columnValue.value as boolean) : isChecked || false}
			name={columnConfig.name}
			onChange={async (e) => {
				e.preventDefault();
				e.stopPropagation();

				const storedValue = columnValue?.value ? (columnValue.value as boolean) : false;

				setIsChecked(!storedValue);
				const saved = await runOrToast(
					() =>
						updatePerson({
							id: row.id,
							columnId: columnConfig.id,
							customColumnName: columnConfig.name,
							value: !storedValue,
							customColumnType: type,
						}).unwrap(),
					t("errors.saveFailed")
				);

				if (!saved) {
					setIsChecked(storedValue);
				}
			}}
		/>
	);
};
